// extracted by css-extract-rspack-plugin
export default {"container":"CreateIndexDialog-module__container__pNkWofT","header":"CreateIndexDialog-module__header__lUAqcuK","headerSubtext":"CreateIndexDialog-module__headerSubtext__I3WnCVe"};